import axios from "axios";
import { API_URL } from "../config";


export interface NfcTag {
  id: number;
  token: string;
  name: string;
  working_area: number | null;
  working_area_name: string | null;
}


export interface NfcTagListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: NfcTag[];
}


export interface NfcTagWorkingAreaPayload {
  working_area: number | null;
}


export interface NfcTagRequestPayload {
  quantity: number;
  shipping_address: string;
}


export interface NfcTagRequestResponse {
  success: boolean;
  message?: string;
  copy_sent_to?: string;
}

export type NfcTagFilter = "assigned" | "unassigned";

export type NfcTagListParams = {
  filter_by?: NfcTagFilter;
  search?: string;
  page?: number;
  page_size?: number;
  paginate?: boolean;
};


export const getNfcTagList = async ( token: string, params?: NfcTagListParams): Promise<NfcTag[] | NfcTagListResponse> => {
  const queryParams = {
    ...params,
    ...(params?.paginate === undefined
      ? {}
      : { paginate: params.paginate }),
  };

  const response = await axios.get(`${API_URL}/presenze/company/nfc-tags/`,
    {
      headers: {
        'Authorization': token,
      },
      params: Object.keys(queryParams).length
        ? queryParams
        : undefined,
    }
  );

  return response.data;
};

export const getNfcTag = async (token: string, id: string | number): Promise<NfcTag> => {
  const response = await axios.get(`${API_URL}/presenze/company/nfc-tags/${id}/`,
    {
      headers: {
        'Authorization': token,
      },
    }
  );

  return response.data;
};


export const patchNfcTagWorkingArea = async (
  token: string,
  id: string | number,
  workingAreaId: number | null
): Promise<NfcTag> => {
  const payload: NfcTagWorkingAreaPayload = {
    working_area: workingAreaId,
  };

  const response = await axios.patch(`${API_URL}/presenze/company/nfc-tags/${id}/`,
    payload,
    {
      headers: {
        'Authorization': token,
      },
    }
  );

  return response.data;
};



export const requestNfcTags = async (
  token: string,
  payload: NfcTagRequestPayload
): Promise<NfcTagRequestResponse> => {
  const response = await axios.post(`${API_URL}/presenze/company/nfc-tags/request/`,
    payload,
    {
      headers: {
        'Authorization': token,
      },
    }
  );

  return response.data;
};
